import React, { memo } from 'react';

import bn from '../../generalUtils/benames';

const bemClass = bn.create('customRadioButton');

const CustomRadioButton = props => {
  let { name = '', onChange, options, className = '', inputClassName = '', isSingleOption = false } = props;

  if (isSingleOption) {
    const { value, id, checked, disabled, label, defaultChecked } = props;
    options = [
      {
        label: label,
        value: value || label,
        id: id || value,
        checked: checked || false,
        disabled: disabled || false,
        defaultChecked: defaultChecked
      }
    ];
  }

  return options.map(item => {
    const { value, id, checked, disabled, label, defaultChecked, isvisibleRadioBtn = true } = item;
    const isAddDisableClass = disabled ? 'disabledToggle' : '';

    if (!isvisibleRadioBtn) {
      return null;
    }

    return (
      <div key={id || value} className={bemClass.b(className)}>
        <input
          type="radio"
          id={id || value}
          value={value || label}
          name={name}
          checked={checked || false}
          defaultChecked={defaultChecked}
          onChange={onChange}
          disabled={disabled || false}
          className={`customRadioButton-input ${inputClassName} ${isAddDisableClass}`}
        />
        <label
          htmlFor={id || value}
          className={`customRadioButton-label ${disabled ? 'disabled' : 'active'}`}
        />
        {label && (
          <label
            title={disabled ? 'Disabled' : label}
            htmlFor={id || value}
            className={`radiolabel ${isAddDisableClass}`}
          >
            {label}
          </label>
        )}
      </div>
    );
  });
};

CustomRadioButton.displayName = 'CustomRadioButton';
export default memo(CustomRadioButton);
